import { getFileExtension, getMimeType } from '@common/utils/fileNameHelpers';

export const downloadResponseFile = (fileName: string) => async (data: Response) => {
  if (data.body) {
    const blob = await data.blob();
    const fileExt = getFileExtension( fileName );
    const newBlob = new Blob([blob], { type: getMimeType(fileExt) });
    const url = URL.createObjectURL(newBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileExt.length > 0 ? `${fileName}` : `${fileName}.xlsx`;
    a.click();
  }
};

export const downloadResponseZipFile = (fileName: string) => async (data: Response) => {
  if (data.body) {
    const blob = await data.blob();

    const newBlob = new Blob([blob], { type: 'application/zip' });
    const url = URL.createObjectURL(newBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.zip`;
    a.click();
  }
};
